import axios from 'axios'
import { toast } from 'react-toastify'
import config from '../config/environment'

// Create axios instance with base configuration
const api = axios.create({
  baseURL: config.ADMIN_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important for cookie-based authentication
})

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Redirect to admin login on 401 errors
      window.location.href = '/admin/login'
    }
    return Promise.reject(error)
  }
)

export const modelsService = {
  // Get all models with pagination and filters
  async getModels(params = {}) {
    try {
      const response = await api.get('/models', { params })
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch models'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  // Get model by ID
  async getModelById(modelId) {
    try {
      const response = await api.get(`/models/${modelId}`)
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to fetch model'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  // Create new model
  async createModel(modelData) {
    try {
      const response = await api.post('/models', modelData)
      toast.success('Model created successfully')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to create model'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  // Update model
  async updateModel(modelId, modelData) {
    try {
      const response = await api.put(`/models/${modelId}`, modelData)
      toast.success('Model updated successfully')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to update model'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },

  // Delete model
  async deleteModel(modelId) {
    try {
      const response = await api.delete(`/models/${modelId}`)
      toast.success('Model deleted successfully')
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to delete model'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  }
}

export default modelsService
